import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PaginationService {

    productsData: Object;
    paginationSubject = new Subject<any>();
    paginationListSubject = new Subject<any>();
    productSwitchSubject = new Subject<any>();

    constructor() { }


    /**
       * 
       * @param data 
       */
    setPaginationData(data: any): void {

        this.paginationSubject.next(data);
    }

    /**
  * Method to listen for language change
  * @returns Observable<any>
  */
    listenerPaginationData(): Observable<any> {

        return this.paginationSubject.asObservable();
    }
    /**
       * 
       * @param data 
       */
    setPaginationListData(data: any): void {

        this.paginationListSubject.next(data);
    }

    /**
  * Method to listen for language change
  * @returns Observable<any>
  */
    listenerPaginationListData(): Observable<any> {

        return this.paginationListSubject.asObservable();
    }











}